/**
 * @generated SignedSource<<178183698c01a63e37610dd9f001ee09>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableContainer_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespFeaturedItemsGridLazy_user" | "PdpRespRefetchableSimilarItemsGrid_user" | "PdpRespSharedHeroCarousel_user" | "PdpRespSharedPrintDetailsLazy_user" | "PdpRespSharedSidebarSellerInfoAndContact_user" | "PdpRespUnavailableDetailsTabs_user" | "PdpSharedFeaturedRelatedItemsCarouselLazy_user" | "PdpSharedItemFavorites_user" | "PdpSharedSellerItemsCarousel_user">;
  readonly " $fragmentType": "PdpRespUnavailableContainer_user";
};
export type PdpRespUnavailableContainer_user$key = {
  readonly " $data"?: PdpRespUnavailableContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "afterDisplayAndBtNone"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableDetailsTabs_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetailsLazy_user"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedItemFavorites_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedSidebarSellerInfoAndContact_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerItemsCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespRefetchableSimilarItemsGrid_user"
    },
    {
      "condition": "afterDisplayAndBtNone",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFeaturedRelatedItemsCarouselLazy_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespFeaturedItemsGridLazy_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "af4c92bf929a96ef375b6a0dfdee65ce";

export default node;
